const designEmbeds = {
  muro: {
    acqua: {
      piece3dSrc: "https://app.vectary.com/p/1rRAm1G7iMPOGyVaId45dO",
      squareMeter3dSrc: "https://app.vectary.com/p/4vFtI1S6dyGo0C5c0crJJv",
    },
    alpes: {
      piece3dSrc: "https://app.vectary.com/p/7aMwUMl4EzFvuYocA52APm",
      squareMeter3dSrc: "https://app.vectary.com/p/2O1v36kYLrBl8LkXBmlnSi",
    },
    angular: {
      piece3dSrc: "https://app.vectary.com/p/6O2ohMb8hhF3k9pXBWUqzi",
      squareMeter3dSrc: "https://app.vectary.com/p/50I4uMk0R2Bt3kN27uYQ0O",
    },
    arista: {
      piece3dSrc: "https://app.vectary.com/p/7QpMK3mCO0spUOvLxX3fmT",
      squareMeter3dSrc: "https://app.vectary.com/p/2yq9I8Wa6b61bb7gpxsZwo",
    },
    arrecife: {
      piece3dSrc: "https://app.vectary.com/p/3XCjUloeyfty8vTjgJLtKT",
      squareMeter3dSrc: "https://app.vectary.com/p/0LpJSp9jERVvTFGi4HVt2h",
    },
    boomer: {
      piece3dSrc: "https://app.vectary.com/p/2lNcwu8oUa6SoL81dW7Siu",
      squareMeter3dSrc: "https://app.vectary.com/p/76CrLlogcfUYFdMZzc41bh",
    },
    cali: {
      piece3dSrc: "https://app.vectary.com/p/19vGzb9Rix5dFSBQ9zQQaD",
      squareMeter3dSrc: "https://app.vectary.com/p/2uG20s4Qm4z2QIsqKaNVkk",
    },
    caramel: {
      piece3dSrc: "https://app.vectary.com/p/5MxTjaNOS9lG4JndTWgcwR",
      squareMeter3dSrc: "https://app.vectary.com/p/4nXHs2vF7QUWDnBUi2LR4V",
    },
    cenote: {
      piece3dSrc: "https://app.vectary.com/p/4nEXPxiH927EYyveiJai0C",
      squareMeter3dSrc: "https://app.vectary.com/p/7e7TSqkCyyo7McEHmiagrX",
    },
    creciente: {
      piece3dSrc: "https://app.vectary.com/p/3WfZnSqKiCvWgHPJf3jkGF",
      squareMeter3dSrc: "https://app.vectary.com/p/4y6JZEt2eTiqQp16vpYKoX",
    },
    dalia: {
      piece3dSrc: "https://app.vectary.com/p/345iK1Vu23DQXjGmNIT5Jg",
      squareMeter3dSrc: "https://app.vectary.com/p/6Po2lOXL4dockDzCrjQOwP",
    },
    "desfase-a": {
      piece3dSrc: "https://app.vectary.com/p/2hPPbLAJIgf1bwxQvQiB48",
      squareMeter3dSrc: "https://app.vectary.com/p/4N6KuGoaBZJ18EZc4w7Jnv",
    },
    "desfase-b": {
      piece3dSrc: "https://app.vectary.com/p/2Cs8q7uB5562oKL4qpHKuJ",
      squareMeter3dSrc: "https://app.vectary.com/p/2Cs8q7uB5562oKL4qpHKuJ",
    },
    dot: {
      piece3dSrc: "https://app.vectary.com/p/6xZCo25dhLbIcrgbmZ1d5C",
      squareMeter3dSrc: "https://app.vectary.com/p/6I4YNn9eUbaa2x2Q2jVDnw",
    },
    duna: {
      piece3dSrc: "https://app.vectary.com/p/3HE3toeXLS7GuSxjxXregS",
      squareMeter3dSrc: "https://app.vectary.com/p/2HjYrmxdR5dYOwrKln66Uk",
    },
  },
};

export const getDesignEmbeds = (collectionId, designId) => designEmbeds[collectionId]?.[designId] || null;